<template>
  <div class="v-container">
    <div class="v-page-header">SaaS菜单管理</div>
    <div class="v-header tool-bar">
      <el-button type="primary" size="small" @click="add()">
        <i class="el-icon-plus"></i>
        添加菜单
      </el-button>
    </div>
    <div class="v-content" v-loading="loading">
      <el-table ref="mTable" :data="lists" :row-key="getRowKeys" border size="small" style="width: 100%">
        <el-table-column fixed width="100">
          <template slot-scope="scope" v-if="scope.row.pid > 0">
            <span style="color: #666; font-size: 12px">|--</span>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="80"></el-table-column>
        <el-table-column prop="title" label="页面名称" width="120"></el-table-column>
        <el-table-column prop="path" label="菜单归属" width="100">
          <template slot-scope="scope">{{ scope.row.origin_type == 1 ? '平台' : 'SaaS' }}</template>
        </el-table-column>
        <el-table-column prop="path" label="页面路径"></el-table-column>
        <el-table-column label="状态" width="70" align="center">
          <template slot-scope="scope">
            <el-button @click="upldateShow(scope.row)" v-if="scope.row.is_show == 1" :loading="scope.row.showLoading" size="min" type="success">启用</el-button>
            <el-button @click="upldateShow(scope.row)" v-else :loading="scope.row.showLoading" size="min" type="danger">禁用</el-button>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="140">
          <template slot-scope="scope">
            <el-button @click="add(scope.row)" :disabled="scope.row._level == 2" type="default" size="min" icon="el-icon-plus"></el-button>
            <el-button @click="edit(scope.row)" type="default" size="min" icon="el-icon-edit"></el-button>
            <el-button @click="del(scope.row)" :loading="scope.row.loading" type="default" size="min" icon="el-icon-delete"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <add-edit v-if="addEdit" :isShow.sync="addEdit" @getlist="getMenusList" :row="row" :add-edit-type="addEditType" />
  </div>
</template>

<script>
import addEdit from './components/add-edit';

export default {
  components: { addEdit },
  data() {
    return {
      lists: [],
      addEdit: false,
      loading: false,
      addEditType: 1, // 1添加 2修改
      row: null,
    };
  },

  created() {
    this.getMenusList();
  },

  methods: {
    getRowKeys(row) {
      return row.id;
    },

    async getMenusList() {
      this.loading = true;
      try {
        let res = await this.api.userAdmin.getPermission({ type: 1 });
        this.lists = res.data;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    //添加
    add(row) {
      this.addEditType = 1;
      this.row = row || null;
      this.addEdit = true;
    },

    //修改
    edit(row) {
      this.addEditType = 2;
      this.row = row;
      this.addEdit = true;
    },

    //删除
    del(row) {
      this.$confirm('确认删除么?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          row.loading = true;
          try {
            let res = await this.api.userAdmin.deletePermission({ id: row.id });
            this.$message.success(res.message);
            row.loading = false;
            this.silentDel(row.id);
          } catch (ex) {
            row.loading = false;
          }
        })
        .catch(() => {});
    },

    //静态删除数据
    silentDel(id, menus) {
      menus = menus ? menus : this.lists;
      menus.forEach((item, index) => {
        if (item.id == id) {
          menus.splice(index, 1);
        }
        if (Array.isArray(item.children)) {
          this.silentDel(id, item.children);
        }
      });
    },

    //更新状态
    async upldateShow(row) {
      this.$set(row, 'showLoading', true);
      try {
        let _row = Object.assign({}, row);
        delete _row.children;
        _row.is_show = _row.is_show == 1 ? 2 : 1;
        await this.api.user.editPermission(_row);
        row.is_show = _row.is_show;
        this.$message.success('更新成功');
      } catch (e) {
        console.error(e);
      }
      row.showLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.tool-bar {
  padding: 0 0 15px 0;
}
</style>
